import React from 'react';

import ProjectCard from './ProjectCard';
import project from './Projects';
import Cover from '../../Cover';

const Project = () => {
  return (
    <Cover>
      <div className=" items-center justify-center " id={'project'}>
        <div className="flex items-center justify-center">
          <div className="text-center w-[80%] mx-auto items-center justify-center  ">
            <h1 className="text-4xl font-extrabold mb-[20px]">My Projects</h1>
            <div className=" flex flex-row justify-between gap-y-[30px] flex-wrap">
              {project.map((item, i) => (
                <ProjectCard item={item} i={i} />
              ))}
            </div>
            <div>
              <button className=" lg:py-4 lg:px-8 py-2 px-4 bg-yellow-500 hover:bg-transparent border-[1px] border-yellow-500 rounded-box shadow-xl mt-8 mb-8 font-extrabold text-2xl text-white ">
                <a href="/project" target="_blank" rel="noreferrer">
                  View All Project
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Cover>
  );
};

export default Project;
